import { ENV } from "../Utils";

export class Course {
  baseApi = ENV.BASE_API;

  async createCourse(accessToken, data) {
    try {
      // Actualiza el valor de 'miniature' con el URL de la imagen o el valor adecuado
      data.miniature = data.file; // Asumiendo que `data.file` tiene la imagen para la miniatura
      // Elimina el campo `file` de `data` ya que no lo necesitamos en el envío
      delete data.file;
      const formData = new FormData();
      // Añadir todos los datos restantes al FormData
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getCourses(params) {
    try {
      const pageFilter = `page=${params?.page || 1}`;
      const limitFilter = `limit=${params?.limit || 10}`;
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSES}?${pageFilter}&${limitFilter}`;

      const response = await fetch(url);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateCourse(accessToken, idCourse, data) {
    try {
      data.miniature = data.file;

      // Elimina el campo `file` de `data` ya que no lo necesitamos en el envío
      delete data.file;
      const formData = new FormData();
      // Añadir todos los datos restantes al FormData
      Object.keys(data).forEach((key) => formData.append(key, data[key]));
      //console.log("data", data);  // Verifica que `file` no esté en `data` y que `miniature` tenga el valor correcto
      //console.log("formData", formData);  // Verifica que `file` no esté en `formData` y que `miniature` tenga el valor correcto
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/${idCourse}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteCourse(accessToken, idCourse) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/${idCourse}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
